import Highway from '@dogstudio/highway';
import { animation } from '../animations/home';
import { hero } from '../components/hero';
import { mq } from '../util/matchMedia';

class Home extends Highway.Renderer {

  onEnter() {
    mq.init();
    hero.init();
    animation.play();
  }

  onLeave() {
    animation.pause();
  }
}

export default Home;
